module.exports = __webpack_public_path__ + "img/cloth_g3_hat-11.370832f2.svg";